<template>
  <v-row
    :style="{ opacity: old ? null : null }"
  >
    <v-col
      v-for="(item, index) of items.filter(x => (!categoryFilter || x.CategoryID === categoryFilter) && (!hideRec || !x.Recurrent))"
      :key="`${item.ID}-${index}`"
      cols="12"
      sm="12"
      md="12"
      @click="() => old ? null : onEdit(item)"
    >
      <event
        :contentTypeID="contentTypeID"
        :data="item"
        :locale="locale"
        :activityList="day.date >= '2026-04-20' ? activityListNew : activityList"
        :eventType="eventType"
        :isPaxCount="isPaxCount"
        :onPaxCount="handleSelectEventPaxCount"
        :old="old"
        :style="{ border: checkNoActtiv(item, acttivData) ? '5px solid red' : item.Recurrent ? '1px solid orange' : null,
                  opacity: item.HideEvent ? '20%' : '100%'
                }"
      />
    </v-col>
    <v-col
      v-if="!old && !disabledAdd"
      cols="12"
      sm="12"
      md="12"
      style="text-align: center;"
    >
      <v-btn
        @click="handleAdd"
        color="primary"
        dark
        outlined
        small
        style="margin-bottom: 20px;"
      >
        <v-icon>mdi-plus</v-icon> {{ $t('common.add', locale) }}
      </v-btn>
    </v-col>
      <event-pax-count
        v-if="isPaxCount"
        :selectedEvent="selectedEventPaxCount"
        :onClose="handleCloseEventPaxCount"
        :selectedPlanID="planID"
      />
  </v-row>
</template>
<script>
import api from '@/services/api'
import Event from './Event'
import EventPaxCount from './paxCount/EventPaxCount'
export default {
  components: {
    Event,
    EventPaxCount,
  },
  props: {
    planID: {
      type: String,
      required: true,
    },
    contentTypeID: {
      type: String,
      required: true,
    },
    config: {
      type: Array,
      default: null,
    },
    day: {
      type: Object,
      required: true,
    },
    disabledAdd: {
      type: Boolean,
      default: true,
    },
    onEdit: {
      type: Function,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    forceRefresh: {
      type: String,
      default: null,
    },
    activityList: {
      type: Array,
      default: null,
    },
    activityListNew: {
      type: Array,
      default: null,
    },
    eventType: {
      type: String,
      required: true,
    },
    categoryFilter: {
      type: String,
      default: null,
    },
    old: {
      type: Boolean,
      default: false,
    },
    hideRec: {
      type: Boolean,
      default: false,
    },
    isPaxCount: {
      type: Boolean,
      default: false,
    },
    acttivData: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    items: [],
    selectedEventPaxCount: null,
  }),
  watch: {
    'contentTypeData.Categories' () {
      this.handleGetData()
    },
    'contentTypeDataID' () {
      this.handleGetData()
    },
    'day.date' () {
      this.handleGetData()
    },
    forceRefresh () {
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleGetData () {
      this.items = []
      api.getAllWithoutLimit ('dviewcontent', `v1/public/activity-barcelo-01/events/${this.contentTypeID}/${this.planID}/${this.day.date}`)
        .then((response) => {
          this.items = response.map(item => {
            item.Title = item.Title ? JSON.parse(item.Title) : { es: '' }
            item.Description = item.Description ? JSON.parse(item.Description) : { es: '' }
            item.Place = item.Place ? JSON.parse(item.Place) : { es: '' }
            return item
          })
        })
    },
    handleAdd () {
      this.onEdit({
        EventID: null,
        ContentTypeID: this.contentTypeID,
        PlanID: this.planID,
        Time: 960,
        TimeEnd: 1020,
        Date: this.day.date,
        WeekdayID: this.day.weekdayID,
      })
    },
    handleSelectEventPaxCount (item) {
      this.selectedEventPaxCount = {
        id: item.ID,
        adults: item.Adults ? item.Adults : 0,
        children: item.Children ? item.Children : 0,
        source: item.Source,
        date: item.Date,
      }
    },
    handleCloseEventPaxCount (refresh) {
      this.selectedEventPaxCount = null
      if (refresh) this.handleGetData()
    },
    checkNoActtiv(v, acttiv) {
      if (!acttiv) return false
      return acttiv.events.filter(x => x.date === v.Date && x.barceloID === v.BarceloID).length === 0
    }
  },
}
</script>
